export const uniqById = (array) =>
  array.reduce(
    (acc, b) =>
      acc.map(({ id }) => id).includes(b.id) ? acc : [...acc, ...[b]],
    []
  );
